<!--  -->
<template>
  <div class="firm-body">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>招聘管理</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ routeName }}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ list[isIndex].name }}</span>
    </p>
    <div class="box">
      <div class="active-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="index != isIndex ? 'text-item' : 'text-item-active'"
          @click="activeChange(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div
        class="flex-box2"
        style="margin-top: 20px; font-size: 16px"
        v-if="isIndex != 3"
      >
        <div v-if="isIndex == 0" style="margin-right: 40px">
          <span style="font-size: 14px">应聘者姓名：</span>
          <el-input
            placeholder="请输入应聘者姓名，按enter键搜索"
            style="width: 310px"
            v-model="eliteName"
            @keydown.enter.native="eliteNameChange"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="flex-box">
          <div
            style="
              display: flex;
              align-items: center;
              cursor: pointer;
              margin-right: 15px;
              font-size: 14px;
              height: 40px;
            "
            v-for="(item, index) in exchangeStatusList"
            :key="index"
            @click="statusChange(item)"
          >
            <img
              src="@/assets/imgs/gouxuan@3x.svg"
              alt=""
              v-if="item.checked"
            />
            <img src="@/assets/imgs/weigouxuan@3x.svg" alt="" v-else />
            <span style="margin-left: 10px">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="text-box">
        <div>工作经验：</div>
        <div class="text-box-item">
          <div
            :class="workExperience == item.id ? 'type-box-active' : 'type-box'"
            v-for="(item, index) in workExpEnumList"
            :key="index"
            @click="experienceChange(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="text-box">
        <div>学历要求：</div>
        <div class="text-box-item">
          <div
            :class="education == item.id ? 'type-box-active' : 'type-box'"
            v-for="(item, index) in xlList"
            :key="index"
            @click="qualificationChange(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="text-box">
        <div>薪资待遇：</div>
        <div class="text-box-item">
          <div
            :class="salaryIndex == index ? 'type-box-active' : 'type-box'"
            v-for="(item, index) in salaryList"
            :key="index"
            @click="salaryChange(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="text-box">
        <div>求职状态：</div>
        <div class="text-box-item">
          <div
            :class="jobStatus == item.id ? 'type-box-active' : 'type-box'"
            v-for="(item, index) in jobStatusList"
            :key="index"
            @click="jobStatusChange(item)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div style="float: right; margin-bottom: 20px">
        <!-- 不合适 / 收藏 tab 的批量操作 -->
        <div v-if="isIndex == 3 || isIndex == 2">
          <el-button
            type="primary"
            @click="cancelInappropriateElite('')"
            v-if="isIndex == 3"
            >批量撤销不合适</el-button
          >
          <el-button
            type="primary"
            @click="cancelCollectElite('')"
            v-if="isIndex == 2"
            >批量取消收藏</el-button
          >
        </div>
        <!-- 仅已沟通支持批量不合适 -->
        <el-button type="primary" @click="noSuitable" v-else-if="isIndex == 0"
          >批量不合适</el-button
        >
      </div>
      <div style="margin-top: 40px">
        <el-table
          :data="tableData"
          size="small"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          row-key="id"
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{
            background: '#409eff ',
            textAlign: 'center',
            color: '#ffffff',
            padding: '3px',
            fontSize: '12px',
            fontWeight: '300',
            height: '45px',
            border: 0,
          }"
          @selection-change="selectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column label="精英" width="150"  >
            <template slot-scope="scope">
              <div class="flex-box2" style="justify-content: left">
                <img :src="scope.row.eliteAvatar" alt="" style="width: 20px" />
                <!-- <img src="@/assets/imgs/tx2.png" alt=""> -->
                <span style="margin-left: 10px">{{ scope.row.eliteName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sexName" label="性别"> </el-table-column>
          <el-table-column prop="age" label="年龄"> </el-table-column>
          <el-table-column label="基本信息" >
            <template slot-scope="scope">
              <span style="margin-left: 10px"
                >{{ scope.row.educationName }} | {{ scope.row.workExpYear }}年</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="lastWorkCompany"
            label="最近工作经历"
            width="250"
          >
          </el-table-column>
          <el-table-column label="微信" v-if="isIndex != 3" width="50">
            <template slot-scope="scope">
              <img
                src="@/assets/imgs/weixin@3x.svg"
                alt=""
                style="cursor: pointer; height: 25px;margin-top: 5px;"
                v-if="scope.row.eliteWechat"
                @click.stop="showContactCopy(scope.row, true)"
              />
              <el-popover
                v-else
                placement="top"
                width="180"
                trigger="hover"
                popper-class="elite-contact-popover"
              >
                <div class="contact-popover-content">
                  <div class="contact-popover-text">确认索要对方微信号？</div>
                  <el-button
                    type="text"
                    size="mini"
                    class="contact-popover-btn"
                    @click.stop="onClick(scope.row, true)"
                  >
                    确认
                  </el-button>
                </div>
                <img
                  slot="reference"
                  src="@/assets/imgs/weixin-weijiaohuan@3x.svg"
                  alt=""
                  style="cursor: pointer; height: 25px;margin-top: 5px;"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="手机" v-if="isIndex != 3" width="50"> 
            <template slot-scope="scope">
              <img
                src="@/assets/imgs/dianhua@3x.svg"
                alt=""
                style="cursor: pointer; height: 25px;margin-top: 5px;"
                v-if="scope.row.elitePhone"
                @click.stop="showContactCopy(scope.row, false)"
              />
              <el-popover
                v-else
                placement="top"
                width="180"
                trigger="hover"
                popper-class="elite-contact-popover"
              >
                <div class="contact-popover-content">
                  <div class="contact-popover-text">确认索要对方手机号？</div>
                  <el-button
                    type="text"
                    size="mini"
                    class="contact-popover-btn"
                    @click.stop="onClick(scope.row, false)"
                  >
                    确认
                  </el-button>
                </div>
                <img
                  slot="reference"
                  src="@/assets/imgs/dianhua-weijiaohuan@3x.svg"
                  alt=""
                  style="cursor: pointer; height: 25px;margin-top: 5px;"
                />
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="lastWorkCompany" label="约面试" v-if="isIndex != 3">
            <template>
            <img src="@/assets/imgs/yuemianshi@3x.svg" alt="" v-if=""> 
              <img src="@/assets/imgs/yuemianshi-weiyue@3x.svg" alt="" style="cursor: pointer;">
            </template>
          </el-table-column> -->
          <el-table-column
            prop="jobStatusName"
            label="求职状态"
          >
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  justify-content: space-around;
                  align-items: center;
                  min-width: 100px;
                "
              >
                <!-- <img src="@/assets/imgs/zaixiangoutong@3x.svg" alt="" style="cursor: pointer;width: 25px;"> -->
                <!-- <img src="@/assets/imgs/zaixiangoutong-buzaixian.png" alt="" v-if="isIndex==3"> -->
                <img
                  src="@/assets/imgs/shoucang@3x.svg"
                  alt=""
                  v-if="isIndex == 2"
                  style="cursor: pointer; width: 25px"
                  @click.stop="cancelCollectElite(scope.row)"
                />
                <div
                  style="
                    cursor: pointer;
                    width: 60px;
                    height: 25px;
                    background: #409eff ;
                    border-radius: 5px;
                    font-size: 10px;
                    text-align: center;
                    line-height: 25px;
                    color: #fff;
                  "
                  @click.stop="addInappropriateElite(scope.row)"
                  v-if="isIndex == 0"
                >
                  不合适
                </div>
                <div
                  style="
                    cursor: pointer;
                    width: 65px;
                    height: 25px;
                    background: #409eff ;
                    border-radius: 5px;
                    font-size: 10px;
                    text-align: center;
                    line-height: 25px;
                    color: #fff;
                  "
                  v-if="isIndex == 3"
                  @click.stop="cancelInappropriateElite(scope.row)"
                >
                  撤销不合适
                </div>
                <div
                  style="
                    cursor: pointer;
                    width: 60px;
                    height: 25px;
                    background: #409eff ;
                    border-radius: 5px;
                    font-size: 10px;
                    text-align: center;
                    line-height: 25px;
                    color: #fff;
                  "
                  @click.stop="ckClick(scope.row)"
                >
                  查看
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <dialogModel :visible.sync="visible" :footer="false">
        <div style="padding: 20px 0">
          <div style="text-align: center" v-if="isWx">
            微信号：{{ rowObj.eliteWechat
            }}<el-button @click="copyText(rowObj.eliteWechat)" type="text"
              >复制</el-button
            >
            <el-button @click="handleReapplyFromCopy" type="text">重新申请</el-button>
          </div>
          <div style="text-align: center" v-else>
            手机号：{{ rowObj.elitePhone
            }}<el-button @click="copyText(rowObj.elitePhone)" type="text"
              >复制</el-button
            >
            <el-button @click="handleReapplyFromCopy" type="text">重新申请</el-button>
          </div>
        </div>
      </dialogModel>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
      <Instruction
        :EliteCard="EliteCard"
        :Credit="Credit"
        :Instruction="Instruction"
        :willConsumeCard="contactApplyWillConsume"
        :dialogInstruction="dialogInstruction"
        @handleCloseInstruction="onCloseInstructionDialog"
        @handleInstruction="handleInstructionContactApply"
      />
    </div>
  </div>
</template>

<script>
import {
  workExpEnumList,
  xlList,
  salaryList,
  jobStatusList,
} from "@/assets/js/common.js";
import * as API from "@/assets/api/firm/firmRecruit.js";
import {
  judgeCanCommunicateElite,
  getPropCount,
} from "@/assets/api/firm/Opportunity.js";
// 引入分页组件
import paging from "../../../../components/paging.vue";
import Instruction from "../components/Instruction.vue";
export default {
  components: { paging, Instruction },
  data() {
    return {
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 10, //总数
      },
      routeName: "",
      // 原始菜单
      originList: [
        {
          name: "精英沟通",
          num: "",
          val:'company:elite:communicate',
        },
        {
          name: "精英管理",
          num: "",
          val:'company:elite:manage',
        },
        {
          name: "精英收藏",
          num: "",
          val:'company:elite:collect',
        },
        {
          name: "不合适",
          num: "",
          val:'company:elite:inappropriate',
        },
      ],
      list: [], // 权限过滤后显示
      isIndex: 0,
      workExpEnumList,
      xlList,
      salaryList,
      jobStatusList,
      // 工作经验Id
      workExperience: -1,
      // 学历Id
      education: -1,
      // 薪资范围最小值
      salaryMin: "",
      // 薪资范围最大值
      salaryMax: "",
      salaryIndex: 0,
      // 求职状态
      jobStatus: -1,
      // 名称
      eliteName: "",
      // 1：微信 2：手机
      exchangeStatusList: [
        {
          name: "全部",
          id: 0,
          checked: true,
        },
        {
          name: "已交换微信号",
          id: 1,
          checked: false,
        },
        {
          name: "已交换手机号",
          id: 2,
          checked: false,
        },
      ],
      // 列表筛选参数：exchangeStatus（1微信 2手机），全部传空
      exchangeStatus: "",
      // 列表数据
      tableData: [],
      // 不合适勾选列表
      delList: [], // 选中行的主键 id / eliteId
      noSuitableList: [], // 批量不合适所需的数据 { eliteId, hopeSalaryMin, hopeSalaryMax }
      visible: false,
      rowObj: "",
      isWx: true,
      EliteCard: 0,
      Credit: 0,
      Instruction: 0,
      dialogInstruction: false,
      /** judge 需消耗精英卡时，确认后用于 contactApply */
      contactApplyPending: null,
      /** Instruction 文案：true 消耗一张精英卡；false 仅展示剩余卡并确认申请 */
      contactApplyWillConsume: true,
    };
  },
  created() {
    this.routeName = this.$route.name;

    // 🔥 先过滤权限
    this.filterListByPermission();

    this.isIndex = this.resolveInitialTabIndex();

    this.tabChange();
    this.getPropCountElite();
  },
  mounted() {
    // 监听联系方式状态变化事件，刷新收藏列表
    this.$root.$on('eliteContactStatusChanged', this.handleContactStatusChanged);
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off('eliteContactStatusChanged', this.handleContactStatusChanged);
  },
  methods: {
    // ==============================================
    // ✅ 核心：权限过滤，无权限直接删除 tab
    // ==============================================
    filterListByPermission() {
      const permissionCodesStr = localStorage.getItem("permissionCodes");
      const permissionArr = permissionCodesStr ? JSON.parse(permissionCodesStr) : [];
      
      this.list = this.originList.filter(item => {
        if (!item.val) return true;
        return permissionArr.includes(item.val);
      });
    },

    /** 从详情返回等场景：优先用 tab 标识（val/名称）对齐权限过滤后的列表，其次用 index */
    resolveInitialTabIndex() {
      if (!this.list.length) return 0;
      const tab = this.$route.query.tab;
      if (tab) {
        const found = this.list.findIndex(
          (x) => x.val === tab || x.name === tab
        );
        if (found >= 0) return found;
      }
      let idx = this.normalizeRouteTabIndex(this.$route.query.index);
      if (idx >= this.list.length) {
        idx = this.list.length - 1;
      }
      if (idx < 0) idx = 0;
      return idx;
    },

    // ==============================================
    // ✅ 修复：根据当前显示的 list 自动匹配正确方法
    // ==============================================
    getCurrentTabMethod() {
      const valMap = {
        "company:elite:communicate": "getCommunicateList",
        "company:elite:manage": "getPaidList",
        "company:elite:collect": "getCollectList",
        "company:elite:inappropriate": "getInappropriateList",
      };
      const currentItem = this.list[this.isIndex];
      if (!currentItem) return null;
      const methodName = valMap[currentItem.val];
      return this[methodName] || null;
    },

    isCurrentTab(tabVal) {
      const cur = this.list[this.isIndex];
      return !!(cur && cur.val === tabVal);
    },

    /** 列表接口返回的总条数（兼容字段名） */
    extractListTotal(res) {
      const d = res && res.data;
      if (!d) return 0;
      const raw =
        d.total != null
          ? d.total
          : d.totalCount != null
            ? d.totalCount
            : d.recordsTotal;
      const n = Number(raw);
      return Number.isFinite(n) && n >= 0 ? n : 0;
    },

    /** 更新某个 tab 角标数量；若当前正在该 tab，同步分页 total */
    updateEliteTabNum(tabVal, total) {
      const n = Number(total);
      const safe = Number.isFinite(n) && n >= 0 ? n : 0;
      const item = this.list.find((x) => x.val === tabVal);
      if (item) item.num = safe;
      const cur = this.list[this.isIndex];
      if (cur && cur.val === tabVal) {
        this.pagingObj.totalDevice = safe;
      }
    },

    // 联系方式状态时间（用于判断 7 天后才能重新申请）
    getContactStatusTime(row, isWx) {
      return isWx ? row.eliteWechatStatusTime : row.elitePhoneStatusTime;
    },
    // 是否已过 7 天（未过则不允许再次申请）
    canReapplyContactByTime(row, isWx) {
      const raw = this.getContactStatusTime(row, isWx);
      if (!raw) return { ok: true };
      const t = new Date(raw);
      const ms = t.getTime();
      if (Number.isNaN(ms)) return { ok: true };
      const limitMs = ms + 7 * 24 * 60 * 60 * 1000;
      if (Date.now() >= limitMs) return { ok: true };
      return {
        ok: false,
        retryAt: new Date(limitMs),
      };
    },
    // exchangeStatusList(id:0全部 1微信 2手机) -> exchangeStatus(1微信 2手机)
    mapExchangeStatusByStatusId(id) {
      if (id === 1) return 1;
      if (id === 2) return 2;
      return "";
    },
    // 兼容路由 ?index=：当前使用新索引 0~3；历史旧值仅兜底 4(不合适) -> 3
    normalizeRouteTabIndex(raw) {
      if (raw === undefined || raw === null || raw === "") {
        return 0;
      }
      const idx = Number(raw);
      if (Number.isNaN(idx) || idx < 0) {
        return 0;
      }
      if (idx > 4) {
        return 3;
      }
      // 历史链接旧值：4（不合适）映射到新值 3
      if (idx === 4) return 3;
      // 新索引 0~3 直接使用，避免 goBack 时错误减一
      return idx;
    },
    copyText(textToCopy) {
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$tool.PromptBox("success", "复制成功");
    },
    // 复制弹窗内的“重新申请”
    handleReapplyFromCopy() {
      if (!this.rowObj) return;
      const row = this.rowObj;
      const isWx = this.isWx;
      // 关闭复制弹窗后再走申请流程，避免弹层叠加
      this.visible = false;
      this.$nextTick(() => {
        this.onClick(row, isWx);
      });
    },
    getPropCountElite() {
      getPropCount({ data: 1 })
        .then((res) => {
          if (res && res.data && res.data.propCount != null) {
            this.EliteCard = res.data.propCount;
          }
        })
        .catch(() => {});
    },
    onCloseInstructionDialog() {
      this.dialogInstruction = false;
      this.contactApplyPending = null;
      this.contactApplyWillConsume = true;
    },
    handleInstructionContactApply() {
      if (!this.contactApplyPending) {
        this.dialogInstruction = false;
        this.contactApplyWillConsume = true;
        return;
      }
      const { eliteId, contactType } = this.contactApplyPending;
      this.dialogInstruction = false;
      this.contactApplyPending = null;
      this.contactApplyWillConsume = true;
      API.contactApply({
        data: {
          eliteId,
          contactType: Array.isArray(contactType)
            ? Number(contactType[0])
            : Number(contactType),
        },
      }).then((applyRes) => {
        if (applyRes.code === 0) {
          this.$tool.PromptBox("success", "申请成功");
          this.getPropCountElite();
          this.tabChange(true);
        } else {
        }
      });
    },
    // 获取企业管理员已沟通的精英列表
    getCommunicateList() {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          workExperience: this.workExperience == -1 ? "" : this.workExperience,
          education: this.education == -1 ? "" : this.education,
          salaryMin: this.salaryMin,
          salaryMax: this.salaryMax,
          jobStatus: this.jobStatus == -1 ? "" : this.jobStatus,
          eliteName: this.eliteName,
          exchangeStatus: this.exchangeStatus,
        },
      };
      API.communicateList(data).then((res) => {
        if (res.code == 0) {
          const total = this.extractListTotal(res);
          this.updateEliteTabNum("company:elite:communicate", total);
          if (this.isCurrentTab("company:elite:communicate")) {
            this.tableData = res.data.list || [];
          }
        }
      });
    },
    // 获取精英管理列表
    getPaidList() {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          workExperience: this.workExperience == -1 ? "" : this.workExperience,
          education: this.education == -1 ? "" : this.education,
          salaryMin: this.salaryMin,
          salaryMax: this.salaryMax,
          jobStatus: this.jobStatus == -1 ? "" : this.jobStatus,
          eliteName: this.eliteName,
          exchangeStatus: this.exchangeStatus,
        },
      };
      API.paidList(data).then((res) => {
        if (res.code == 0) {
          const total = this.extractListTotal(res);
          this.updateEliteTabNum("company:elite:manage", total);
          if (this.isCurrentTab("company:elite:manage")) {
            this.tableData = res.data.list || [];
          }
        }
      });
    },
    // 已交换联系方式：仅弹出复制弹窗，不走申请接口
    showContactCopy(row, isWx) {
      if (!this.$checkAction()) return;
      this.rowObj = row;
      this.isWx = isWx;
      this.visible = true;
    },
    // 未交换：先 judgeCanCommunicateElite，确认后 contactApply
    onClick(row, isWx) {
      if (!this.$checkAction()) return;
      const can = this.canReapplyContactByTime(row, isWx);
      if (!can.ok) {
        const dt = can.retryAt;
        const mm = String(dt.getMonth() + 1).padStart(2, "0");
        const dd = String(dt.getDate()).padStart(2, "0");
        const hh = String(dt.getHours()).padStart(2, "0");
        const mi = String(dt.getMinutes()).padStart(2, "0");
        this.$tool.PromptBox(
          "warning",
          `7天内不可重复申请，请于${mm}-${dd} ${hh}:${mi}后再试`
        );
        return;
      }
      const applyContactType = isWx ? 1 : 0; // 1微信 0电话
      const judgeUserId =
        row.userId != null && row.userId !== "" ? row.userId : row.eliteId;
      const eliteId =
        row.eliteId != null && row.eliteId !== "" ? row.eliteId : judgeUserId;
      if (eliteId == null || eliteId === "") {
        this.$tool.PromptBox("warning", "无法识别精英信息");
        return;
      }
      judgeCanCommunicateElite({ data: { userId: judgeUserId } }).then(
        (res) => {
          if (res.code !== 0) {
            return;
          }
          const needConsumeCard = res.data === false;
          if (!needConsumeCard) {
            // 不再二次弹框：Popover 点击“确认”即直接索要
            API.contactApply({
              data: {
                eliteId,
                contactType: applyContactType,
              },
            }).then((applyRes) => {
              if (applyRes.code === 0) {
                this.$tool.PromptBox("success", "申请成功");
                this.tabChange(true);
              } else {
                this.$tool.PromptBox(
                  "warning",
                  applyRes.msg || applyRes.message || "申请失败"
                );
              }
            });
            return;
          }
          getPropCount({ data: 1 }).then((c) => {
            if (c.code !== 0) {
              return;
            }
            const count =
              c.data && c.data.propCount != null ? c.data.propCount : 0;
            this.EliteCard = count;
            if (needConsumeCard && count <= 0) {
              this.$confirmWithScroll("已无可用精英卡，是否前往购买？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  this.$router.push("/Firm/propHire");
                })
                .catch(() => {});
              return;
            }
            this.Instruction = 0;
            this.contactApplyWillConsume = true;
            this.contactApplyPending = {
              eliteId,
              contactType: applyContactType,
            };
            this.dialogInstruction = true;
          });
        }
      );
    },
    // 处理联系方式状态变化事件
    handleContactStatusChanged() {
      // 如果当前在收藏tab，刷新收藏列表
      if (this.isCurrentTab("company:elite:collect")) {
        this.getCollectList();
      }
    },
    // 企业管理员已收藏的精英列表
    getCollectList() {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          workExperience: this.workExperience == -1 ? "" : this.workExperience,
          education: this.education == -1 ? "" : this.education,
          salaryMin: this.salaryMin,
          salaryMax: this.salaryMax,
          jobStatus: this.jobStatus == -1 ? "" : this.jobStatus,
          eliteName: this.eliteName,
          exchangeStatus: this.exchangeStatus,
        },
      };
      API.collectList(data).then((res) => {
        if (res.code == 0) {
          const total = this.extractListTotal(res);
          this.updateEliteTabNum("company:elite:collect", total);
          if (this.isCurrentTab("company:elite:collect")) {
            this.tableData = res.data.list || [];
          }
        }
      });
    },
    // 获取不合适精英列表
    getInappropriateList() {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          workExperience: this.workExperience == -1 ? "" : this.workExperience,
          education: this.education == -1 ? "" : this.education,
          salaryMin: this.salaryMin,
          salaryMax: this.salaryMax,
          jobStatus: this.jobStatus == -1 ? "" : this.jobStatus,
          eliteName: this.eliteName,
          exchangeStatus: this.exchangeStatus,
        },
      };
      API.inappropriateList(data).then((res) => {
        if (res.code == 0) {
          const total = this.extractListTotal(res);
          this.updateEliteTabNum("company:elite:inappropriate", total);
          if (this.isCurrentTab("company:elite:inappropriate")) {
            this.tableData = res.data.list || [];
          }
        }
      });
    },
    // tab切换
    activeChange(index) {
      this.isIndex = index;
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    tabChange(isTrue) {
      // 🔥 自动获取当前应该调用的方法，不会再乱调用
      const method = this.getCurrentTabMethod();
      if (method) {
        method.call(this);
      }

      if (!isTrue) {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
        });
      }
    },
    // 手机微信切换
    statusChange(item) {
      this.exchangeStatusList.forEach((items) => {
        items.checked = false;
      });
      item.checked = true;
      this.exchangeStatus = this.mapExchangeStatusByStatusId(item.id);
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    // 按下回车
    eliteNameChange() {
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    // 工作经验切换
    experienceChange(item) {
      this.workExperience = item.id;
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    // 学历切换
    qualificationChange(item) {
      this.education = item.id;
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    // 薪资待遇切换
    salaryChange(item, index) {
      this.salaryIndex = index;
      this.salaryMin = item.hopeMinSalary;
      this.salaryMax = item.hopeMaxSalary;
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    // 求职状态切换
    jobStatusChange(item) {
      this.jobStatus = item.id;
      this.pagingObj.currentPage = 1;
      this.tabChange();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.tabChange(true);
    },
    // 表格选择
    selectionChange(row) {
      // 批量操作的 id 列表
      this.delList = row.map((item) => {
        return this.isIndex == 3 || this.isIndex == 2 ? item.id : item.eliteId;
      });
      // 批量不合适需要的参数（仿照单条不合适的结构）
      this.noSuitableList = row.map((item) => {
        return {
          eliteId: item.eliteId,
          hopeSalaryMin: item.hopeSalaryMin,
          hopeSalaryMax: item.hopeSalaryMax,
        };
      });
    },
    // 批量不合适
    noSuitable() {
      if (!this.$checkAction()) return;
      let that = this;
      if (this.delList.length > 0) {
        this.$confirmWithScroll("是否把勾选中的求职者标记为不合适？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          that.addInappropriateElite();
        });
      } else {
        that.$tool.PromptBox("warning", "请至少勾选一条数据后进行操作！");
      }
    },
    // 批量取消不合适
    cancelInappropriateElite(item) {
      if (!this.$checkAction()) return;
      let that = this;
      if (item) {
        that
          .$confirmWithScroll("是否把该求职者标记为不合适移除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            let data = {
              data: {
                ids: [item.id],
              },
            };
            API.cancelInappropriateElite(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功！");
                this.tabChange();
              }
            });
          });
      } else {
        if (that.delList.length > 0) {
          that
            .$confirmWithScroll("是否把勾选中的求职者标记为不合适移除？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              let data = {
                data: {
                  ids: that.delList,
                },
              };
              API.cancelInappropriateElite(data).then((res) => {
                if (res.code == 0) {
                  this.$tool.PromptBox("success", "操作成功！");
                  this.tabChange();
                }
              });
            });
        } else {
          this.$tool.PromptBox("warning", "请至少勾选一条数据后进行操作！");
        }
      }
    },
    // 不合适
    addInappropriateElite(item) {
      if (!this.$checkAction()) return
      let that = this;
      if (item) {
        this.$confirmWithScroll("是否把该求职者标记为不合适？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let data = {
            data: [
              {
                eliteId: item.eliteId,
                hopeSalaryMin: item.hopeSalaryMin,
                hopeSalaryMax: item.hopeSalaryMax,
              },
            ],
          };
          API.addInappropriateElite(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功！");
              this.tabChange();
            }
          });
        });
      } else {
        // 批量不合适，按照接口单条结构组装为数组
        let data = {
          data: that.noSuitableList,
        };
        API.addInappropriateElite(data).then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功！");
            this.tabChange();
          }
        });
      }
    },
    // 取消收藏
    cancelCollectElite(item) {
      if (!this.$checkAction()) return;
      let that = this;
      if (item) {
        that
          .$confirmWithScroll("是否取消该求职者收藏？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            let data = {
              data: {
                ids: [item.id],
              },
            };
            API.cancelCollectElite(data).then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功！");
                this.tabChange();
              }
            });
          });
      } else {
        if (that.delList.length > 0) {
          that
            .$confirmWithScroll("是否把勾选中的数据取消收藏？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              let data = {
                data: {
                  ids: that.delList,
                },
              };
              API.cancelCollectElite(data).then((res) => {
                if (res.code == 0) {
                  this.$tool.PromptBox("success", "操作成功！");
                  this.tabChange();
                }
              });
            });
        } else {
          this.$tool.PromptBox("warning", "请至少勾选一条数据后进行操作！");
        }
      }
    },
    //斑马线
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "row-style";
      }
      return "";
    },
    ckClick(row) {
      this.$router.push({
        path: "/Firm/eliteDetails",
        query: {
          row: JSON.stringify({
            name: this.list[this.isIndex].name,
            tabVal: this.list[this.isIndex].val,
            id: row.eliteId,
            index: this.isIndex,
            // 详情页用于初始化收藏状态
            collectOrNot: this.isIndex == 2 ? 1 : row.collectOrNot,
            collectId: this.isIndex == 2 ? row.id : row.collectId,
          }),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table .row-style {
  background: #eee;
}

/deep/.el-input__inner {
  font-size: 12px;
}

/deep/.elite-contact-popover {
  padding: 10px 12px;
}

.contact-popover-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-popover-text {
  font-size: 12px;
  color: #333;
  margin-bottom: 8px;
  line-height: 18px;
}

/deep/ .contact-popover-btn.el-button--mini {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1;
}

.firm-body {
  .box {
    width: 1200px;
    min-height: 700px;
    box-sizing: border-box;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 30px 20px;
    font-size: 14px;

    .active-list {
      display: flex;
      align-items: center;

      .text-item {
        background-color: #eee;
        width: 110px;
        font-size: 12px;
        padding: 8px 5px;
        text-align: center;
        margin-right: 20px;
        border-radius: 5px;
        cursor: pointer;
        box-sizing: border-box;
      }

      .text-item-active {
        background-color: rgba(97, 144, 232, 0.2);
        width: 110px;
        font-size: 12px;
        padding: 8px 5px;
        text-align: center;
        margin-right: 20px;
        border-radius: 5px;
        box-sizing: border-box;
        cursor: pointer;
        color: #409eff ;
      }
    }

    .text-box {
      display: flex;
      margin: 20px 0;
      font-size: 12px;

      .text-box-item {
        display: flex;
        cursor: pointer;

        .type-box-active {
          margin-right: 30px;
          color: #409eff ;
        }

        .type-box {
          margin-right: 30px;
          color: #333;
        }
      }
    }
  }
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
